<div class="flex flex-col gap-6 p-4">
  <div class="grid grid-flow-col grid-cols-[max-content_1fr_max-content_1fr] gap-10">
    <div class="">
      <div class="text-text-color text-sm font-semibold font-['Inter']">Project</div>
      <div class="text-text-color text-sm font-semibold font-['Inter']">TA created by</div>
      <div class="text-text-color text-sm font-semibold font-['Inter']">Primary Approver</div>
      <div class="text-text-color text-sm font-semibold font-['Inter']">Secondary Approver</div>
    </div>
    <div class="">
      <div class="text-text-color text-sm font-normal font-['Inter']">{{taSubmission()!.projectCode ?? "No project set."}}</div>
      <div class="text-text-color text-sm font-normal font-['Inter']">{{taSubmission()!.created?.createdByName ?? ''}}</div>
      <div class="text-text-color text-sm font-normal font-['Inter']">{{this.taSubmission()?.primaryApprover?.name ?? "Not set."}}</div>
      <div class="text-text-color text-sm font-normal font-['Inter']">{{this.taSubmission()?.secondaryApprover?.name ?? "Not set."}}</div>
    </div>
    <div class="">
      <div class="text-text-color text-sm font-semibold font-['Inter']">Purpose</div>
      <div class="text-text-color text-sm font-semibold font-['Inter']">Notes</div>
      <div class="text-text-color text-sm font-semibold font-['Inter']">Create Date</div>
    </div>
    <div class="">
      <div class="text-text-color text-sm font-normal font-['Inter']">{{taSubmission()!.purpose ?? "No purpose set."}}</div>
      <div class="text-text-color text-sm font-normal font-['Inter']">{{taSubmission()!.purposeNotes ?? "-"}}</div>
      <div class="text-text-color text-sm font-normal font-['Inter']">{{!!taSubmission()?.created?.created ? (taSubmission()!.created!.created | date: 'dd/MM/yy') : '' }}</div>
    </div>
  </div>

  @if (loading()) {
    <div class="flex flex-col items-center gap-3">
      <div class="text-text-color text-sm font-normal font-['Inter'] italic">Loading event history...</div>
      <taspinner size="sm"></taspinner>
    </div>
  } @else if (eventLogs.length > 0) {
    <p-table [value]="eventLogs" [tableStyle]="{ 'min-width': '60rem' }" class="border-[1px] border-surface-400 rounded table-auto w-fit max-w-full">
      <ng-template #header>
        <tr class="text-surface-800 text-xs font-semibold font-['Roboto_Condensed']">
          <th class="rounded-tl">Event Type</th>
          <th class="grow">Date/Time</th>
          <th>Who</th>
          <th>Description/Comments</th>
          <th class="rounded-tr"></th>
        </tr>
      </ng-template>
      <ng-template #body let-event let-rowIndex="rowIndex">
        <tr class="text-surface-800 text-xs font-['Roboto_Condensed']">
          <td class="align-top" [ngClass]="{'rounded-bl' : (rowIndex === eventLogs.length - 1)}">
            <span>{{ toEventTypeDisplayText(event) }}</span>
          </td>
          <td class="align-top" [title]="event.eventDate | date:'dd/MM/yyyy HH:mm:ss'">
            {{ event.eventDate | date:'dd/MM/yy' }} / {{ event.eventDate | date:'HH:mm' }}
          </td>
          <td class="align-top">
            {{ event.userEmail === 'systemuser' ? 'System' : event.userEmail }}
          </td>
          <td class="align-top">
            <div>
              {{ commentText(event) }}
            </div>
            @if (selectedEvent() === event) {
              <div class="flex flex-col gap-2 pt-2">
                @for (data of selectedEventMetadata(); track data;) {
                  <div class="flex gap-2">
                    <div class="text-surface-500 text-xs font-normal font-['Roboto_Condensed']">{{ toEventMetaTypesText(data[0]) }}</div>
                    <div class="text-surface-500 text-xs font-normal font-['Roboto_Condensed']">{{ toEventMetaValueText(data[0], data[1]) }}</div>
                  </div>
                } @empty {
                  <div class="text-surface-500 text-xs font-normal font-['Roboto_Condensed'] italic">No extra details.</div>
                }
              </div>
            }
          </td>
          <td class="align-top" [ngClass]="{'rounded-br' : (rowIndex === eventLogs.length - 1)}">
            <div class="cursor-pointer text-primary-500" (click)="viewExtraDetails(event)">{{selectedEvent() === event ? 'Less Details' : 'More Details'}}</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <div class="text-text-color text-sm font-normal font-['Inter'] line-clamp-1 italic">{{"No audit log events."}}</div>
  }
  <div class="flex justify-end gap-2">
    <p-button size="small" label="Close" severity="primary" (click)="closeDialog(null)" />
  </div>
</div>
